
let startY = 0
let moveY = 0

let touchStart = e => {
  startY = e.touches[0].clientY
  e.stopPropagation()
}

let touchMove = (e, el) => {
  moveY = e.touches[0].clientY
  var yDiff = moveY - startY // yDiff大于0为下拉,小于0上拉
  if (yDiff > 0 && el.scrollTop === 0 && e.cancelable) {
    e.preventDefault()
  }
  if (
    yDiff < 0 &&
    el.scrollTop === el.scrollHeight - el.offsetHeight &&
    e.cancelable
  ) {
    e.preventDefault()
  }
}
export default {
  touchStart, touchMove
}
